import React, { useEffect, useState } from 'react';
import { data } from '../../configs/menu-config';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Input,
  notification,
  Row,
  Typography,
} from 'antd';
import authService from '../../services/auth';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData, setFirebaseToken } from '../../redux/slices/auth';
import {
  fetchRestSettings,
  fetchSettings,
} from '../../redux/slices/globalSettings';
import { useTranslation } from 'react-i18next';
import { PROJECT_NAMES } from '../../configs/app-global';
import { setMenu } from '../../redux/slices/menu';
import brandLogo from '../../assets/images/brand_logo.png';
const { Title } = Typography;

const credentials = [
  {
    login: 'admin@aboeltalabat.com',
    password: 'aboeltalabat',
  },
  // {
  //   login: 'manager@aboeltalabat.com',
  //   password: 'manageraboeltalabat',
  // },
  // {
  //   login: 'sellers@aboeltalabat.com',
  //   password: 'selleraboeltalabat',
  // },
  // {
  //   login: 'moderator@aboeltalabat.com',
  //   password: 'moderatoraboeltalabat',
  // },
  // {
  //   login: 'delivery@aboeltalabat.com',
  //   password: 'deliveryaboeltalabat',
  // },
  // {
  //   login: 'temp@gmail.com',
  //   password: '12345678',
  // },
];

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { settings } = useSelector((state) => state.globalSettings);
  // const [recaptcha, setRecaptcha] = useState(null);
  // const handleRecaptchaChange = (value) => {
  //   setRecaptcha(value);
  // };

  const handleLogin = (values) => {
    const body = {
      password: values.password,
    };
    if (values.email && values.email.includes('@')) {
      body.email = values.email;
    } else if (values.email) {
      body.phone = values.email.replace(/[^0-9]/g, '');
    }
    setLoading(true);
    authService
      .login(body)
      .then((res) => {
        const user = {
          fullName: res.data.user.firstname + ' ' + res.data.user.lastname,
          role: res.data.user.role,
          urls: data[res.data.user.role],
          img: res.data.user.img,
          token: res.data.access_token,
          email: res.data.user.email,
          id: res.data.user.id,
          shop_id: res.data.user?.shop?.id,
        };
        if (user.role === 'waiter') {
          dispatch(
            setMenu({
              icon: 'user',
              id: 'orders-board',
              name: 'my.orders',
              url: 'waiter/orders-board',
            })
          );
        }
        if (user.role === 'user') {
          notification.error({
            title: t('ERROR_101'),
          });
          return;
        }
        localStorage.setItem('token', res.data.access_token);
         dispatch(setFirebaseToken(res.data.access_token));
        dispatch(setUserData(user));
        if (user.role === 'admin') {
          dispatch(fetchSettings());
        } else {
          dispatch(fetchRestSettings());
        }
      })
      .finally(() => setLoading(false));
  };

  const copyCredentials = (event, item) => {
    event.preventDefault();
    form.setFieldsValue({ email: item.login, password: item.password });
  };

  useEffect(() => {
    dispatch(fetchRestSettings());
  }, []);

  return (
    <div className='login-container'>
      <div className='container d-flex flex-column justify-content-center h-100 align-items-end'>
        <Row justify='center' gutter={24}>
              <Col>
            <img 
              src={brandLogo} 
              alt='Brand Logo' 
              style={{ 
                maxWidth: '300px', 
                height: 'auto', 
                borderRadius: '50%', 
                width: '200px', 
                height: '200px', 
                objectFit: 'cover' 
              }} 
            />
          </Col>
          <Col>
            <Card className='card'>
              <div className='my-4 pl-4 pr-4 w-100'>
                <div className='app-brand text-center'>
                  <Title className='brand-logo'>
                    {settings?.title || PROJECT_NAMES}
                  </Title>
                </div>
                <Row justify='center'>
                  <Col>
                    <Form
                      name='login-form'
                      layout='vertical'
                      form={form}
                      onFinish={handleLogin}
                      style={{ width: '420px' }}
                    >
                      <Form.Item
                        name='email'
                        label='البريد الالكتروني او رقم الهاتف'
                        rules={[
                          {
                            required: true,
                            message: 'ادخل الايميل من فضلك!',
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <MailOutlined className='site-form-item-icon' />
                          }
                          placeholder='البريد الالكتروني او رقم الهاتف'
                        />
                      </Form.Item>
                      <Form.Item
                        name='password'
                        label='كلمة المرور'
                        rules={[
                          {
                            required: true,
                            message: 'ادخل كلمة المرور من فضلك!',
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={
                            <LockOutlined className='site-form-item-icon' />
                          }
                          placeholder='كلمة المرور'
                        />
                      </Form.Item>
                      {/* <Recaptcha onChange={handleRecaptchaChange} /> */}
                      <Form.Item className='login-input mt-4'>
                        <Button
                          type='primary'
                          htmlType='submit'
                          className='login-form-button'
                          loading={loading}
                        >
                          {t('تسجيل الدخول')}
                        </Button>
                      </Form.Item>
                      {/* { (
                        <Descriptions bordered size='small'>
                          {credentials.map((item, idx) => (
                            <React.Fragment key={idx}>
                              <Descriptions.Item span={2} label={item.login}>
                                {item.password}
                              </Descriptions.Item>
                              <Descriptions.Item span={1}>
                                <a
                                  href='/'
                                  className='copy-link'
                                  onClick={(event) =>
                                    copyCredentials(event, item)
                                  }
                                >
                                  {t('Copy')}
                                </a>
                              </Descriptions.Item>
                            </React.Fragment>
                          ))}
                        </Descriptions>
                      )} */}
                      {' '}
                      {/* {(
                        <Descriptions size='small'>
                          <Descriptions.Item span={4} label='Login'>
                            {credentials[0].login}
                          </Descriptions.Item>
                          <Descriptions.Item span={4} label='Password'>
                            {credentials[0].password}
                          </Descriptions.Item>
                        </Descriptions>
                      )} */}
                    </Form>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
      
        </Row>
      </div>
    </div>
  );
};
export default Login;

